module.exports = __webpack_public_path__ + "img/360-konventionella-maskiner.9c12444b.jpg";